/*
 Created by qing on 2022/5/19 下午9:54
 Des:
 */

import BaseItem from "../BaseItem";
import {DATA_TYPE__JSON, FORM_ITEM__TABLE, FORM_ITEM__THIRD_MAP} from "../types";

class ThirdMap extends BaseItem {

  constructor() {
    super()
    this.value = {}

    this.coordinateType = "BUBBLE" //坐标类型 PATH 轨迹  BUBBLE 气泡
    this.queryDataType = "FORM" //FORM 表单数据 THIRD 第三方数据
    this.showCurrentLocation = "YES" //显示当前定位
    this.pointIcon = '' // 点位图标
    this.mapScale = "13" // 地图比例尺
    this.autoRefresh = 'YES'
    this.refreshFrequency = 10
    this.lengthWidthScale = "4:3" // 地图尺寸
    this.formDataConfig = {
      "dataAppId":"", //数据源的 appId
      "dataFormId":"", //数据源的 formId
      "detailViewId": 'dataHandle', // 查看详情关联的视图 dataHandle
      //数据卡片信息
      "showDistance":"YES",
      "locationFieldId":"", // 轨迹定位字段
      "sortList":[
        {
          fieldId: "updateTime",
          sortType: -1 // -1 降序 1 正序、、 -1：Z-A  1:A-Z 、、 -1最新在前， 1最旧在前
        }
      ],
      "filter":{
        relation: 'and',
        jumpEmpty: 0,
        conditionList: []
      }, //数据筛选信息
      "bubbleContent":"", // 起泡显示信息 使用表单的自定义表单标题信息
      "cardFieldIdList":[], //卡片显示字段
      "titleColor":"", //标题颜色
      "contentColor":""  //内容颜色
    }
    this.thirdApiConfig = {
      "requestUrl":"请求的url", // 可以添加控件字段
      "methodType":0, // 0 get 1 post
      "headerList":[],
      "paramType":0, // 0 json 1 x-www-form-urlencoded
      "paramList":[], //x-www-form-urlencoded 类型
      "requestBody":"",   //可以添加控件字段 json 类型取此参数
    }
    this.refreshFieldIdList = []
    this.defaultValue = {}

  }

  get title() {
    return this.fieldTitle || ThirdMap._title
  }

  set title(val) {
    this.fieldTitle = val
  }
}

ThirdMap._title = '地图'
ThirdMap.type = FORM_ITEM__THIRD_MAP
ThirdMap.use = true
ThirdMap.prototype.icon = 'el-icon-video-play'

ThirdMap.prototype.type = ThirdMap.type
ThirdMap.prototype.dataType = DATA_TYPE__JSON
ThirdMap.prototype.defaultValueList = []

ThirdMap.prototype.filterOpts = [
  {
    name: '为空',
    method: 'empty'
  },
  {
    name: '不为空',
    method: 'not_empty'
  },
]
ThirdMap.prototype.getValue = function () {
  return this.value
}
ThirdMap.prototype.setValue = function (val) {
  if (this.parent && this.parent.type === FORM_ITEM__TABLE) {
    return
  }
  this.value = val || []
}
ThirdMap.prototype.setConf = function (opts) {
  if (opts) {
    this.setBase(opts)
    this.coordinateType = opts.coordinateType
    this.queryDataType = opts.queryDataType
    this.showCurrentLocation = opts.showCurrentLocation
    this.pointIcon = opts.pointIcon
    this.mapScale = opts.mapScale
    this.autoRefresh = opts.autoRefresh
    this.refreshFrequency = opts.refreshFrequency
    this.lengthWidthScale = opts.lengthWidthScale
    this.formDataConfig = opts.formDataConfig
    this.thirdApiConfig = opts.thirdApiConfig
    this.refreshFieldIdList = opts.refreshFieldIdList
  }
}
ThirdMap.prototype.getConf = function () {
  const base = this.getBase()
  return {
    ...base,
    coordinateType: this.coordinateType,
    queryDataType: this.queryDataType,
    showCurrentLocation: this.showCurrentLocation,
    pointIcon: this.pointIcon,
    mapScale: this.mapScale,
    autoRefresh: this.autoRefresh,
    refreshFrequency: this.refreshFrequency,
    lengthWidthScale: this.lengthWidthScale,
    formDataConfig:this.formDataConfig,
    thirdApiConfig: this.thirdApiConfig,
    refreshFieldIdList: this.refreshFieldIdList
  }
}
ThirdMap.prototype.valueToString = function (value) {
  return ''
}
export default ThirdMap
